export const AROMA_PACKAGE_ID = 24

export function resolveAromaTaskId (value) {
  const taskId = Number(value)
  return Number.isInteger(taskId) && taskId > 0 ? taskId : 119
}

const isProduction = process.env.NODE_ENV === 'production'
export const AROMA_TASK_ID = resolveAromaTaskId(process.env.VUE_APP_AROMA_TASK_ID)
export const AROMA_PRODUCTS = [
  {
    id: 'aroma-liquid',
    packageId: AROMA_PACKAGE_ID,
    taskId: AROMA_TASK_ID,
    packageName: '纯植物精油复配芳香液'
  },
  {
    id: 'sleep-device',
    packageId: 25,
    taskId: !isProduction ? 121 : 80,
    packageName: '睡眠仪'
  },
  {
    id: 'melatonin-magnesium-patch-10',
    packageId: 7,
    taskId: !isProduction ? 122 : 81,
    packageName: '褪黑素镁透皮贴（10c㎡）'
  },
  {
    id: 'melatonin-magnesium-patch-5',
    packageId: 8,
    taskId: !isProduction ? 123 : 82,
    packageName: '褪黑素镁透皮贴（5c㎡）'
  }
]

export function getAromaProductConfig (productId) {
  return AROMA_PRODUCTS.find(item => item.id === productId) || AROMA_PRODUCTS[0]
}

export const PAY_THIRD_PARTY = {
  alipay: 1,
  wechat: 2
}

export function formatPrice (value) {
  const cents = Number(value)
  if (!Number.isFinite(cents)) return '-'
  return (cents / 100).toFixed(2)
}

export function filterCashiersForBrowser (cashiers = [], isWeixin = false) {
  const supported = isWeixin ? PAY_THIRD_PARTY.wechat : PAY_THIRD_PARTY.alipay
  return cashiers.filter(item => Number(item.thirdParty) === supported)
}

export function getPayType (cashier) {
  return Number(cashier?.thirdParty) === PAY_THIRD_PARTY.wechat ? 'wechat' : 'alipay'
}

export function formatPatientBirthday (value) {
  const birthday = String(value || '').trim()
  const date = birthday.match(/^\d{4}-\d{2}-\d{2}/)
  return date ? date[0] : birthday
}

export function buildAromaOrderPayload ({
  task,
  packageData,
  profile,
  shipping,
  cashierTypeId,
  jsCode = '',
  returnUrl,
  productConfig = AROMA_PRODUCTS[0]
}) {
  return {
    hospitalId: task.hospitalId,
    doctorId: task.doctorId,
    cashierTypeId,
    jsCode,
    returnUrl,
    packageId: productConfig.packageId,
    freeTrial: 0,
    totalPackagePrice: packageData.packagePrice,
    payPrice: packageData.packagePrice,
    deposit: 0,
    depositSwitch: 0,
    discountSwitch: 0,
    discountAmount: 0,
    orderTaskId: productConfig.taskId,
    patientName: profile.realName,
    patientBirthday: formatPatientBirthday(profile.birthday),
    patientSex: String(profile.sex) === '0' ? 1 : 2,
    patientMobile: profile.phoneNumber,
    patientAreaProvince: shipping.region[0],
    patientAreaCity: shipping.region[1],
    patientAreaDistrict: shipping.region[2],
    patientAddress: shipping.receiverAddress,
    receiverName: shipping.receiverName,
    receiverMobile: shipping.receiverMobile,
    receiverAreaProvince: shipping.region[0],
    receiverAreaCity: shipping.region[1],
    receiverAreaDistrict: shipping.region[2],
    receiverAddress: shipping.receiverAddress
  }
}

export function getOrderResultState (status) {
  if (Number(status) === 1) return { key: 'pending', title: '待支付', canPay: true }
  if (Number(status) === 2 || Number(status) === 3) {
    return { key: 'success', title: '支付成功!', canPay: false }
  }
  if (Number(status) === 4) return { key: 'closed', title: '订单已关闭', canPay: false }
  return { key: 'checking', title: '支付结果确认中', canPay: false }
}

export function buildPayResultUrl (origin, sn, orderId, productId) {
  const url = new URL('/aroma-report/pay-result', origin)
  if (sn) url.searchParams.set('sn', sn)
  if (orderId !== undefined && orderId !== null && orderId !== '') {
    url.searchParams.set('orderId', orderId)
  }
  if (productId) url.searchParams.set('productId', productId)
  return url.toString()
}
